import React from 'react'
import { PromoBanner as PromoBannerView } from '@mc/certificates-design-system'
import {
  ExperimentVariable,
  TEXT_KEY,
  UrgencyEntries,
  useUrgency,
  URGENCY_TEXT_VARIABLE_NAME,
  StyledVariable,
} from '@mc/feature-variables'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { PromoVariables } from 'pages/certificates/promo'

type PromoBannerProps = {
  banner: NonNullable<PromoVariables['banner']>
  cta: React.ReactNode
  ctaClassNames?: string
  // When set, renders a "Terms apply." link after the banner copy pointing at
  // the promo's terms (fallback: /terms), per design (MCCERTS-2719). Only
  // `terms` is read; discount-state banners pass their promo block.
  promo?: Pick<PromoVariables['promo'], 'terms'>
}

const BANNER_URGENCY_CONFIG = {
  bannerUrgencyText: {
    variableName: URGENCY_TEXT_VARIABLE_NAME,
    variableKey: TEXT_KEY,
  },
} as UrgencyEntries

export const PromoBanner = ({
  banner,
  cta,
  ctaClassNames,
  promo,
}: PromoBannerProps) => {
  const { t } = useTranslation('@mc/certificates')
  const urgencies = useUrgency({
    entries: BANNER_URGENCY_CONFIG,
    variables: banner as unknown as ExperimentVariable,
  })

  return (
    <PromoBannerView
      containerClassName={banner.containerClassName}
      ctaClassNames={ctaClassNames}
      urgencyText={
        urgencies.bannerUrgencyText || promo ? (
          <>
            {urgencies.bannerUrgencyText && (
              <StyledVariable text={urgencies.bannerUrgencyText} />
            )}
            {promo && (
              <>
                {urgencies.bannerUrgencyText ? ' ' : null}
                <a
                  className='mc-text--link text-c-text-tint-2'
                  href={promo.terms || paths.terms}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {t('marketingPages.promo.termsLink')}
                </a>
              </>
            )}
          </>
        ) : undefined
      }
      text={<StyledVariable text={banner.text} />}
      cta={cta}
    />
  )
}
